import NutrientsFilter from '@v2/components/common/presentational/nutrients/nutrients-filter';
import stylesFilterCategory from '@pages/shop/partial/filter-category.styles';
import { useEntity } from '@app/store/rtk.entities.selectors';

export default function Filter({ category, filterBy, setFilterBy }: { category: any, filterBy: string, setFilterBy: Function }) {
    const products = [];
    const categories = [
        useEntity('pouchpacks') || {},
        useEntity('barpacks') || {},
        useEntity('smoothiepacks') || {},
        useEntity('bonebrothpouchpacks') || {}
    ];

    for (const index in categories) {
        for (const key in categories[index]) {
            products.push(categories[index][key])
        }
    }

    return (
        <div className={`category ${stylesFilterCategory.filterContainer} ${category.id}`} id={`${category.id}`}>
            <div className="category-title">
                <h2>Shop All</h2>
            </div>
            <div className="filter-separator"><div>Shop All</div></div>
            <div className="filter-actions">
                {filterBy && <button onClick={ () => setFilterBy(null) } className="button secondary reset">Reset</button>}
                <NutrientsFilter products={products} filterBy={filterBy} setFilterBy={setFilterBy} />
                {filterBy && <button onClick={ () => setFilterBy(null) } className="button secondary reset mobile">Reset</button>}
            </div>
        </div>
    );
}
